import { createSlice } from "@reduxjs/toolkit";

const CustomerSlice = createSlice({
  name: "customer",
  initialState: {
    customer: [],
    inactiveCustomers: [],
    totalCount: 0,
    loading: false,
    error: null,
    successMessage: null,
    errorMessage: null,
    selectedCustomerDetails: null,
    metals: {
      Gold: null,
      Silver: null,
      Platinum: null,
    },
  },
  reducers: {
    fetchCustomerListRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchCustomerListSuccess: (state, action) => {
      const { data, Gold, Silver, Platinum, total } = action.payload || {};

      state.customer = Array.isArray(data.data) ? data.data : [];
      state.totalCount = data.recordsFiltered;
      state.loading = false;
    },
    fetchCustomerListFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    fetchInactiveCustomerListRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchInactiveCustomerListSuccess: (state, action) => {
      state.loading = false;
      state.inactiveCustomers = action.payload?.data || [];
      state.totalCount = action.payload.total;
    },
    fetchInactiveCustomerListFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    clearCustomerMessages: (state) => {
      state.successMessage = null;
      state.errorMessage = null;
    },
    updateCustomerStatusRequest: (state) => {
      state.loading = true;
    },
    updateCustomerStatusSuccess: (state, action) => {
      state.loading = false;
      const { customerId, newStatus } = action.payload;

      // Update the status of the customer in the list
      state.customer = state.customer.map((cust) =>
        cust._id === customerId ? { ...cust, enabled: newStatus } : cust,
      );
    },
    updateCustomerStatusFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    getCustomerDetailsRequest: (state) => {
      state.loading = true;
    },
    getCustomerDetailsSuccess: (state, action) => {
      state.loading = false;
      state.selectedCustomerDetails = action.payload;
    },
    getCustomerDetailsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    sendGiftRequest: (state) => {
      state.loading = true;
      state.successMessage = null;
      state.errorMessage = null;
    },
    sendGiftSuccess: (state, action) => {
      state.loading = false;
      state.successMessage = "Gift sent successfully!";
    },
    sendGiftFailure: (state, action) => {
      state.loading = false;
      state.errorMessage = action.payload;
    },
    extractCustomerDataRequest: (state) => {
      state.loading = true;
      state.error = null;
    },

    extractCustomerDataSuccess: (state, action) => {
      state.loading = false;
      state.successMessage = action.payload || "Customer data export started!";
    },

    extractCustomerDataFailure: (state, action) => {
      state.loading = false;
      state.errorMessage = action.payload;
    },

    // Holdings Export
    holdingsExportRequest: (state) => {
      state.loading = true;
      state.error = null;
    },

    holdingsExportSuccess: (state, action) => {
      state.loading = false;
      state.successMessage = action.payload || "Holdings export started!";
    },

    holdingsExportFailure: (state, action) => {
      state.loading = false;
      state.errorMessage = action.payload;
    },

    // Create / Edit Nominee
    createOrEditNomineeRequest: (state) => {
      state.loading = true;
      state.successMessage = null;
      state.errorMessage = null;
    },

    createOrEditNomineeSuccess: (state, action) => {
      state.loading = false;
      state.successMessage = action.payload || "Nominee saved successfully!";
    },

    createOrEditNomineeFailure: (state, action) => {
      state.loading = false;
      state.errorMessage = action.payload;
    },
    exportInactiveCustomerRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    exportInactiveCustomerSuccess: (state) => {
      state.loading = false;
    },
    exportInactiveCustomerFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    updateCustomerRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateCustomerSuccess: (state) => {
      state.loading = false;
    },
    updateCustomerFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    monthEndReportRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    monthEndReportSuccess: (state, action) => {
      state.loading = false;
      state.successMessage = action.payload || "Month end report generated!";
    },
    monthEndReportFailure: (state, action) => {
      state.loading = false;
      state.errorMessage = action.payload;
    },
  },
});

export const {
  fetchCustomerListRequest,
  fetchCustomerListSuccess,
  fetchCustomerListFailure,
  fetchInactiveCustomerListRequest,
  fetchInactiveCustomerListSuccess,
  fetchInactiveCustomerListFailure,
  updateCustomerStatusRequest,
  updateCustomerStatusSuccess,
  updateCustomerStatusFailure,
  getCustomerDetailsRequest,
  getCustomerDetailsSuccess,
  getCustomerDetailsFailure,
  sendGiftRequest,
  sendGiftSuccess,
  sendGiftFailure,
  extractCustomerDataRequest,
  extractCustomerDataSuccess,
  extractCustomerDataFailure,
  holdingsExportRequest,
  holdingsExportSuccess,
  holdingsExportFailure,
  createOrEditNomineeRequest,
  createOrEditNomineeSuccess,
  createOrEditNomineeFailure,
  exportInactiveCustomerRequest,
  exportInactiveCustomerSuccess,
  exportInactiveCustomerFailure,
  updateCustomerRequest,
  updateCustomerSuccess,
  updateCustomerFailure,
  monthEndReportRequest,
  monthEndReportSuccess,
  monthEndReportFailure,
} = CustomerSlice.actions;

export default CustomerSlice.reducer;
